module.exports = __webpack_public_path__ + "static/media/codecheficon2.42574564.png";